import { render, staticRenderFns } from "./novin-merchant-documents.vue?vue&type=template&id=a04c4746"
import script from "./novin-merchant-documents.vue?vue&type=script&lang=js"
export * from "./novin-merchant-documents.vue?vue&type=script&lang=js"
import style0 from "./novin-merchant-documents.vue?vue&type=style&index=0&id=a04c4746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports